import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserActivity } from '../../../classes/models/user/UserActivity';
import { UserActivityAdapter } from '../../../classes/adapters/response/user/UserActivityAdapter';
import { UserActivityResponse } from '../../../interfaces/response/UserResponses';

/**
 * This service communicates with backend to retrieve user activity data.
 */
@Injectable({
  providedIn: 'root'
})
export class UserActivityService {
  private http = inject(HttpClient);
  private userActivityAdapter = inject(UserActivityAdapter);

  url = environment.apiUrl + '/user-activity';

  /**
   * Retrieves a list of user activity records.
   */
  getUserActivity(): Observable<UserActivity[]> {
    const url = `${this.url}`;
    return this.http.get(url).pipe(
      map((data: UserActivityResponse[]) => data.map(item => this.userActivityAdapter.adapt(item))));
  }
}
